import React from "react";
import { motion } from "framer-motion";

const About: React.FC = () => {
  return (
    <section style={{ padding: "40px 0" }}>
      {" "}
      {/* Added padding to separate sections */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{
          backgroundColor: "#1e1e1e", // Dark background for contrast
          borderRadius: "20px",
          padding: "30px", // More padding for a neater look
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)", // Subtle shadow
          maxWidth: "800px", // Limit width for better readability
          margin: "20px auto", // Centering the content
          width: "100%", // Make it responsive
          boxSizing: "border-box", // Ensure padding is included in width calculations
        }}
        role="region"
        aria-labelledby="about-title"
      >
        <h1
          id="about-title"
          style={{
            fontFamily: "'Psychedelic Font', cursive",
            color: "#ff007f",
            textAlign: "center",
            textShadow: "2px 2px 5px rgba(255, 0, 127, 0.7)", // Text shadow for depth
          }}
        >
          About Methereum
        </h1>
        <img
          src="https://via.placeholder.com/600x300?text=About+Methereum+Psychedelic"
          alt="An artistic representation of Methereum, a meme coin in the crypto landscape"
          style={{
            borderRadius: "20px",
            margin: "20px 0",
            maxWidth: "100%", // Make the image responsive
            height: "auto", // Maintain aspect ratio
            display: "block", // Centering the image
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
        <p
          style={{
            fontSize: "1.2rem",
            color: "#ffffff", // White text for contrast
            lineHeight: "1.6", // Increased line height for readability
          }}
        >
          Methereum is here to shake up the crypto landscape and bring laughter
          back into the world of digital currency. Tired of the endless wave of
          forgettable tokens that flood the market, Methereum proudly stands as
          a beacon of creativity and fun. It’s time for a meme coin that
          embraces the spirit of the internet and delivers real utility
          alongside enjoyment. Forget about the old days of speculative chaos;
          Methereum is here to change the narrative. Launched with stealth and
          no presale, zero taxes, and with liquidity burned, our mission is to
          empower the community. The contract is renounced, ensuring that $METH
          belongs to the people, forever. Driven by the sheer joy of memes, let
          $METH lead you on a memorable journey through the crypto space.
        </p>
      </motion.div>
    </section>
  );
};

export default About;
